var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 27",
    style: {
      enableBackground: "new 0 0 136 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCA0C9;}\n\t.st1{fill:none;stroke:#231F20;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,25.3c-3.9-1.6-9.4-5.6-10.4-10.5c-0.6-3,1-5.1,3.7-5.1c2.4,0,5,3.6,5,3.6c0.9-6.6,8.3-7.6,8.8-0.9 C20.4,18.5,12.7,25.3,12.7,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,25.3c-3.9-1.6-9.4-5.6-10.4-10.5c-0.6-3,1-5.1,3.7-5.1c2.4,0,5,3.6,5,3.6c0.9-6.6,8.3-7.6,8.8-0.9 C20.4,18.5,12.7,25.3,12.7,25.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.5,23.9c4-1.3,9.6-4.9,11-9.7c0.9-3-0.6-5.1-3.3-5.3c-2.4-0.2-5.2,3.2-5.2,3.2c-0.4-6.6-7.6-8.1-8.7-1.5 C115.5,16.7,122.5,23.9,122.5,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.5,23.9c4-1.3,9.6-4.9,11-9.7c0.9-3-0.6-5.1-3.3-5.3c-2.4-0.2-5.2,3.2-5.2,3.2c-0.4-6.6-7.6-8.1-8.7-1.5 C115.5,16.7,122.5,23.9,122.5,23.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.2,22.2 58.2,23.6 60.6,23.6 60.6,24.6 58.2,24.6 58.2,26.8 57.1,26.8 57.1,21.2 60.8,21.2  60.8,22.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 23.6,
    className: "st2",
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 23.6,
    className: "st2",
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.5,21.5c0.4,0.3,0.8,0.6,1,1c0.2,0.4,0.4,0.9,0.4,1.5c0,0.5-0.1,1-0.4,1.5c-0.2,0.4-0.6,0.8-1,1.1 c-0.4,0.3-0.9,0.4-1.5,0.4c-0.6,0-1.1-0.1-1.5-0.4c-0.4-0.3-0.8-0.6-1-1s-0.4-0.9-0.4-1.5c0-0.5,0.1-1,0.4-1.5 c0.2-0.4,0.6-0.8,1-1.1c0.4-0.3,0.9-0.4,1.5-0.4C65.6,21.2,66.1,21.3,66.5,21.5 M64.1,22.4c-0.3,0.2-0.5,0.4-0.6,0.7 c-0.2,0.3-0.2,0.6-0.2,1c0,0.4,0.1,0.7,0.2,1s0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.3 c0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1s-0.1-0.7-0.2-1s-0.4-0.5-0.6-0.7c-0.3-0.2-0.6-0.3-0.9-0.3S64.4,22.2,64.1,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.8,21.5c0.4,0.3,0.8,0.6,1,1c0.2,0.4,0.4,0.9,0.4,1.5c0,0.5-0.1,1-0.4,1.5c-0.2,0.4-0.6,0.8-1,1.1 c-0.4,0.3-0.9,0.4-1.5,0.4c-0.6,0-1.1-0.1-1.5-0.4c-0.4-0.3-0.8-0.6-1-1s-0.4-0.9-0.4-1.5c0-0.5,0.1-1,0.4-1.5 c0.2-0.4,0.6-0.8,1-1.1c0.4-0.3,0.9-0.4,1.5-0.4C72.9,21.2,73.4,21.3,73.8,21.5 M71.4,22.4c-0.3,0.2-0.5,0.4-0.6,0.7 c-0.2,0.3-0.2,0.6-0.2,1c0,0.4,0.1,0.7,0.2,1s0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.3 c0.3-0.2,0.5-0.4,0.6-0.7c0.2-0.3,0.2-0.6,0.2-1s-0.1-0.7-0.2-1s-0.4-0.5-0.6-0.7c-0.3-0.2-0.6-0.3-0.9-0.3S71.7,22.2,71.4,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.6,21.6c0.5,0.2,0.8,0.6,1.1,1s0.4,0.9,0.4,1.4c0,0.5-0.1,1-0.4,1.4s-0.6,0.8-1.1,1 c-0.5,0.2-1,0.4-1.6,0.4h-2v-5.6h2C79.6,21.2,80.1,21.4,80.6,21.6 M80,25.6c0.3-0.2,0.5-0.4,0.7-0.7S81,24.4,81,24 c0-0.4-0.1-0.7-0.2-1s-0.4-0.5-0.7-0.6c-0.3-0.2-0.7-0.2-1.1-0.2h-1v3.7h1C79.4,25.9,79.7,25.8,80,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63,0.8v15.6h-1.4V3.7l-5.1,10h-1l-5.2-10v12.7h-1.4V0.8h1.5l5.6,10.8l5.6-10.8H63z M78.2,16.7l-2.6-2.8 c-0.9,1.5-2.2,2.6-4.3,2.6c-2.7,0-4.7-1.9-4.7-4.2c0-1.9,1.2-3.1,3.5-4.4c-1.3-1.3-2-2.4-2-3.6c0-1.9,1.6-3.3,3.5-3.3 c2,0,3.5,1.5,3.5,3.3c0,1.8-1.4,3-2.8,3.9l3.2,3.5l1.9-3.1l1.1,0.7l-2.1,3.4l2.9,3.1L78.2,16.7z M70.9,8.9c-2,1.1-2.9,2-2.9,3.4 c0,1.6,1.4,2.9,3.3,2.9c1.7,0,2.5-0.8,3.4-2.2L70.9,8.9z M69.4,4.2c0,0.9,0.6,1.6,1.9,3c1.5-0.9,2.3-1.8,2.3-3 c0-1.2-0.8-2.1-2.1-2.1C70.2,2.1,69.4,3.1,69.4,4.2 M91.3,4.2l-1.3,0.5C89.5,3,88.1,2,86.1,2C84,2,82.5,3,82.5,4.8 c0,3.9,8.9,1.8,8.9,7.3c0,2.6-2.1,4.5-5.2,4.5c-2.9,0-4.7-1.4-5.9-3.6l1.2-0.7c0.8,1.7,2.3,3,4.5,3c2.6,0,3.9-1.2,3.9-3.2 c0-3.9-8.9-2-8.9-7.3c0-3.2,2.8-4.2,4.9-4.2C88.4,0.6,90.6,1.7,91.3,4.2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrand);
export default __webpack_public_path__ + "static/media/logo-brand.cfc31925429aa1b201973aeb8962e539.svg";
export { ForwardRef as ReactComponent };